import React from "react";
import {constEmptyData} from "../consts/text.const";

export const EmptyData = () => {
  return <div className="empty-data">{constEmptyData}</div>;
};
